import React from 'react';
import {
  FDDialog, FDDialogActions, FDDialogContent, FDDialogTitle, FDHeadlineText, FDPrimaryActionButton,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

const TaxStrategyItemNoteDialog = ({ open, setOpen, onSubmit }) => {
  const { handleChange } = useMetaLayoutContext();

  return (
    <FDDialog
      open={open}
      onClose={() => setOpen(false)}
      closeOnBackdropClick
      dialogWidth={'md'}
    >
      <FDDialogTitle value={'Notes'} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={3}>
          <FDStack direction={'column'} spacing={1} width={'100%'}>
            <FDHeadlineText size={'sm'} value={'Internal notes'} />
            <MetaControlField attr={'internalNotes'} />
            <FDStack width={'100%'} alignSelf={'flex-end'} justifyContent={'flex-end'} alignItems={'flex-end'} flex={1}>
              <FDSecondaryActionButton alignSelf={'flex-end'} icon={'delete'} onClick={() => handleChange('internalNotes', '')} isFullWidth={false} label={'Clear note'} />
            </FDStack>
          </FDStack>
          <FDStack direction={'column'} spacing={1}>
            <FDHeadlineText size={'sm'} value={'Member note'} />
            <MetaControlField attr={'memberNotes'} />
            <FDStack width={'100%'} alignSelf={'flex-end'} justifyContent={'flex-end'} alignItems={'flex-end'} flex={1}>
              <FDSecondaryActionButton alignSelf={'flex-end'} icon={'delete'} onClick={() => handleChange('memberNotes', '')} label={'Clear note'} />
            </FDStack>
          </FDStack>
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          {...dataAttrs('tax-strategy-item-note-dialog-save-and-close-btn')}
          label={'Save and Close'}
          onClick={() => {
            onSubmit();
            setOpen(false);
          }}
        />
      </FDDialogActions>
    </FDDialog>
  );
};

TaxStrategyItemNoteDialog.defaultProps = {

};

TaxStrategyItemNoteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default TaxStrategyItemNoteDialog;
